import '../css/Content.css';
import React, { useState, useEffect, useRef  } from 'react';
import { Carousel } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import QuizActivity3 from './QuizActivity3';

export const Lesson3 = () => {
  const [mostraTexto, setMostraTexto] = useState({});

 
  const toggleTexto = (id) => {
    setMostraTexto((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const [grupoAtivo, setGrupoAtivo] = useState('');

  // Simula o setTimeout da função original
  useEffect(() => {
    const timeout = setTimeout(() => {
      // avancarConteudo(getCookie("avancar"));
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  const [selectedInfo, setselectedInfo] = useState(null);

  const showInfo = (id) => {
    setselectedInfo(id); // salva o id clicado
  };

  const texts = {
    image1: "Recolhe a água usada em pias, chuveiros e máquinas de lavar, podendo ser direcionada para reuso ou para a rede pública de esgoto. Embora menos contaminada que o esgoto negro, ainda requer tratamento ou descarte adequado.",
    image2: "Coleta a água da chuva de telhados e áreas externas para evitar alagamentos, erosão e infiltração inadequada. É composta por calhas, condutores verticais, caixas de captação e galerias, e geralmente é separada do esgoto sanitário.",
    image3: "Responsável por transportar os dejetos humanos e a água de cozinha para a rede pública ou fossa séptica, utilizando tubulações, sifões e conexões. Deve ser projetado para evitar refluxos, entupimentos e vazamentos.",
    image4: "Rede de tubos que liga o esgoto à atmosfera, equilibrando a pressão nas tubulações para evitar refluxos e vácuos que comprometam o funcionamento dos sifões. Normalmente se projeta acima do telhado.", 
  };
  // const handleClick = (grupo) => {
  //   setGrupoAtivo(grupo);
  // };

  const [openIndex, setOpenIndex] = useState(null);
  const [openIndex2, setOpenIndex2] = useState(null);
  const [openIndex3, setOpenIndex3] = useState(null);
  const [openIndex4, setOpenIndex4] = useState(null);
  const [openIndex5, setOpenIndex5] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const toggleAccordion2 = (index) => {
    setOpenIndex2(openIndex2 === index ? null : index);
  };
  const toggleAccordion3 = (index) => {
    setOpenIndex3(openIndex3 === index ? null : index);
  };
  const toggleAccordion4 = (index) => {
    setOpenIndex4(openIndex4 === index ? null : index);
  };
  const toggleAccordion5 = (index) => {
    setOpenIndex5(openIndex5 === index ? null : index);
  };



  const [showModal3, setShowModal3] = useState(false);
  const [modalContent3, setModalContent3] = useState({ title: "", description: "", image: "" });
  

  // Função para abrir modal e definir conteúdo
  const openModal3 = (e) => {
    const target3 = e.currentTarget;
    console.log(target3)
    setModalContent3({
      title: target3.dataset.title,
      description: target3.dataset.description,
      image: target3.dataset.image,
    });
    setShowModal3(true);

  }



  const containerRef = useRef(null);
  const imageRefs = {
    img1: useRef(null),
    img2: useRef(null),
    img3: useRef(null),
    img4: useRef(null)
  };

  const applyZoom = (event) => {
    const zoomContainer = containerRef.current;
    const rect = zoomContainer.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    Object.values(imageRefs).forEach((ref) => {
      if (ref.current) {
        ref.current.style.transformOrigin = `${xPercent}% ${yPercent}%`;
        ref.current.style.transform = 'scale(2)';
      }
    });
  };

  const resetZoom = () => {
    Object.values(imageRefs).forEach((ref) => {
      if (ref.current) {
        ref.current.style.transform = 'scale(1)';
        ref.current.style.transformOrigin = 'center center';
      }
    });
  };


    const containerRef2 = useRef(null);
    const imageRefs2 = {
      img1: useRef(null),
      img2: useRef(null),
      img3: useRef(null),
      img4: useRef(null)
    };
  
    const applyZoom2 = (event) => {
      const zoomContainer2 = containerRef2.current;
      
      if (!zoomContainer2) {
        console.warn("zoomContainer2 está null");
        return;
      }
  
      const rect2 = zoomContainer2.getBoundingClientRect();
      const x2 = event.clientX - rect2.left;
      const y2 = event.clientY - rect2.top;
  
      const xPercent2 = (x2 / rect2.width) * 100;
      const yPercent2 = (y2 / rect2.height) * 100;
  
      Object.values(imageRefs2).forEach((ref) => {
        if (ref.current) {
          ref.current.style.transformOrigin = `${xPercent2}% ${yPercent2}%`;
          ref.current.style.transform = 'scale(2)';
        }
      });
    };
  
    const resetZoom2 = () => {
      Object.values(imageRefs2).forEach((ref) => {
        if (ref.current) {
          ref.current.style.transform = 'scale(1)';
          ref.current.style.transformOrigin = 'center center';
        }
      });
    };


      const containerRef3 = useRef(null);
      const imageRefs3 = {
        img1: useRef(null),
        img2: useRef(null),
        img3: useRef(null),
        img4: useRef(null)
      };
    
      const applyZoom3 = (event) => {
        const zoomContainer3 = containerRef3.current;
        
        if (!zoomContainer3) {
          console.warn("zoomContainer3 está null");
          return;
        }
    
        const rect3 = zoomContainer3.getBoundingClientRect();
        const x2 = event.clientX - rect3.left;
        const y2 = event.clientY - rect3.top;
    
        const xPercent3 = (x2 / rect3.width) * 100;
        const yPercent3 = (y2 / rect3.height) * 100;
    
        Object.values(imageRefs3).forEach((ref) => {
          if (ref.current) {
            ref.current.style.transformOrigin = `${xPercent3}% ${yPercent3}%`;
            ref.current.style.transform = 'scale(2)';
          }
        });
      };
    
      const resetZoom3 = () => {
        Object.values(imageRefs3).forEach((ref) => {
          if (ref.current) {
            ref.current.style.transform = 'scale(1)';
            ref.current.style.transformOrigin = 'center center';
          }
        });
      };
    
      const containerRef4 = useRef(null);
      const imageRefs4 = {
        img1: useRef(null),
        img2: useRef(null),
        img3: useRef(null),
        img4: useRef(null)
      };
    
      const applyZoom4 = (event) => {
        const zoomContainer4 = containerRef4.current;
        const rect4 = zoomContainer4.getBoundingClientRect();
        const x2 = event.clientX - rect4.left;
        const y2 = event.clientY - rect4.top;
    
        const xPercent4 = (x2 / rect4.width) * 100;
        const yPercent4 = (y2 / rect4.height) * 100;
    
        Object.values(imageRefs4).forEach((ref) => {
          if (ref.current) {
            ref.current.style.transformOrigin = `${xPercent4}% ${yPercent4}%`;
            ref.current.style.transform = 'scale(2)';
          }
        });
      };
    
      const resetZoom4 = () => {
        Object.values(imageRefs4).forEach((ref) => {
          if (ref.current) {
            ref.current.style.transform = 'scale(1)';
            ref.current.style.transformOrigin = 'center center';
          }
        });
      };



  return (
    <>      
      <section className="article" id="article_1" style={{background: 'linear-gradient(161deg, #05A3C7 25%, #001755 100%) fixed',
        backgroundAttachment: 'fixed'}}> {/* className: gradient-background */}

       
        {/* ---------------------------- TELA 1 --------------------------------------- */}

        <article id='l3id1'
         style={{
            display: 'flex',
            minHeight: '100vh',
            background: '#131326',
            position: 'relative'
          }}>



          <div className="container">
            <div
              className="row d-flex align-items-center justify-content-center fontS-18"
              style={{ paddinBottom: "80px", marginTop: '40px' }}
            >

              <div className="col-md-6">
                  <h4 style={{marginBottom: '40px', color: '#ffffff'}}>Olá! Bem-vindos ao <span style={{color: '#00A8D0'}}>Módulo III do Curso de Projeto Hidrossanitário – BIM. </span> </h4>

                  <img src="./img/module1/bg_modulo1_pag1.jpg" style={{width: '100%'}} alt="" />
              </div>


              <div className="col-md-6" style={{height: '85vh', display: 'flex', alignItems: 'center'}}>
                <div style={{ width: '90%', marginTop: '30px', padding: '5% 5% 10% 5% ', borderRadius: '12px', color: '#ffffff', background: 'linear-gradient(161deg, #05A3C7 25%, #000000ff 80%)'}}>
                  <p>
                    Nesta etapa, vamos iniciar a modelagem das instalações de esgoto, explorando recursos do Revit para criar, configurar e detalhar os sistemas hidrossanitários.
                  </p>
                  <p>
                    Ao configurar tipos de tubulação, ajustar rotas, aplicar filtros e modelos de vista, cada elemento do projeto é representado com informações inteligentes. Assim, o modelo digital ganha precisão e se transforma em uma base confiável para gerar toda a documentação técnica.
                  </p>
                  <p>
                    Essa prática permite produzir plantas, cortes, tabelas e folhas de impressão diretamente do modelo, garantindo padronização, clareza e eficiência na entrega do projeto.
                  </p>
                  <p>
                    E o próximo passo nessa jornada será aprender a criar e configurar tubulação para sistemas de esgoto, aplicando métodos que tornam o processo mais ágil e profissional.
                  </p>
                  <p>
                    <strong>Vamos em frente? </strong> 
                  </p>              
                </div>
              </div>
              

            </div>
          </div>

        </article>

                                        

        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}

        <article id='l3id2'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module3/topico2-m3.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>



        {/* ---------------------------- TELA 2 --------------------------------------- */}

       <article
          className="post comecoM2-t"
          style={{ 
            // display: "none", 
            backgroundColor: "#EDE6D8" 
          }}
        >
          <div className="container" style={{paddingBottom: '60px'}}>
            <div className="row">

              <div className="col-md-6" style={{display: 'flex', alignItems: 'center'}}>
                <div className="row">
                  <div className="col-md-12 fontS-18">
                    <p style={{ color: "#000000" }}>
                      O processo de modelagem para o esgotamento sanitário envolve a criação de sistemas que conduzem os efluentes de esgoto das edificações (as águas residuais) até o seu ponto de destinação final, que pode ser uma conexão com a rede pública ou a construção de estações de tratamento de esgoto locais. Essa atividade está associada a modelagem de tubulações, conexões, ralos, caixas de inspeção e outros elementos que compõem o sistema de esgoto sanitário. 
                    </p>               
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div
                  className="row"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "30px",
                    marginBottom: "40px",
                  }}
                >
                  <div className='col-md-12'>
                    <img src="./img/module3/modulo3_pag2.png" style={{width: '80%'}} alt="Imagem mostra instalação hidrossanitária de esgotamento." />
                  </div>

                </div>
              </div>

            </div>

       

            

          </div>
        </article>

        {/* ---------------------------- TELA 3 --------------------------------------- */}

        <article
        className="post avanco8-p2-t"
        style={{
          backgroundColor: '#ffffff'
        }}
      >
        <div className="container" style={{position: 'relative'}}>
          <div className="row fontS-18" style={{ marginBottom: "30px", color: '#000000' }}>
            <p>
              O software Autodesk Revit permite configurar esses sistemas através de parâmetros como diâmetro de tubos, declividade, tipos de materiais e conectividade com outros componentes da instalação hidrossanitária.  
            </p>
            <p>
              <strong>Clique nas legendas abaixo</strong> e conheça os principais sistemas que podem ser modelados nesse software.
            </p>
          </div>

          <div className="row" style={{ paddingBottom: "60px", marginTop: "30px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div className="col-md-8" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", maxWidth: '1000px' }}>

                <img src="./img/module3/modulo3_pag3.png" alt="" style={{width: '100%'}} useMap="#image-map"/>
                  <img
                    src="./img/icon/seta_indica_azul_esquerda.svg"
                    alt=""
                    className="pulse-image"
                    style={{
                      position: "absolute",
                      maxWidth: 35,
                      left: 335,
                      bottom: 75,
                    }}
                  />

                <map name="image-map">
                    <area target="image1" coords="332,533,68,498" shape="rect" onClick={ ()=> showInfo('image1')} style={{cursor: 'pointer'}}/>
                    <area target="image2" coords="66,539,333,569" shape="rect" onClick={ ()=> showInfo('image2')} style={{cursor: 'pointer'}}/>
                    <area target="image3" coords="347,497,646,533" shape="rect" onClick={ ()=> showInfo('image3')} style={{cursor: 'pointer'}}/>
                    <area target="image4" coords="340,538,647,570" shape="rect" onClick={ ()=> showInfo('image4')} style={{cursor: 'pointer'}}/>
                </map>

              </div>            
            </div>              
          </div>

          {selectedInfo && (
                <div
                  style={{
                    position: "absolute",
                    top: "20%",
                    left: "80%",
                    transform: "translateX(-50%)",
                    background: selectedInfo == 'image1' ? '#479FC4' : selectedInfo == 'image2' ? '#47c47f' : selectedInfo == 'image3' ? '#dc9f5d' : selectedInfo == 'image4' ? '#795ddcff' : '#c2c2c2',
                    // background: "rgba(0,0,0,0.7)",
                    color: "#fff",
                    padding: "10px 5px",
                    borderRadius: "10px",
                    zIndex: 10,
                    maxWidth: "80%",
                    textAlign: "center"
                  }}
                >
                  <div className="row">
                    <div className="col-md-12" style={{textAlign: 'right'}}>  
                      <button
                        onClick={() => setselectedInfo(null)}
                        style={{
                          marginLeft: "15px",
                          background: "transparent",
                          border: "1px solid #fff",
                          color: "#fff",
                          borderRadius: "5px",
                          padding: "2px 8px",
                          cursor: "pointer"
                        }}
                      >
                        X
                      </button>
                    </div>
                    <div className="col-md-12" style={{padding: '3% 8% 10% 8%', fontSize: '18px'}}>
                        {texts[selectedInfo]}
                    </div>
                  
                  
                  </div>
                </div>
              )}
        </div>
      </article>


        {/* ---------------------------- TELA 4 --------------------------------------- */}

        <article className="post avanco3-M2-t" style={{ backgroundColor: "#131326", display: 'flex', alignItems: 'center'}}>
          <div className="container" style={{ marginBottom: "60px" }}>
            <div className="row">             
              <p className="fontS-18" style={{ color: "#ffffff", marginBottom: '60px' }}>
                Antes de iniciar a configuração desses sistemas no software é necessário considerar aspectos como:  
              </p>
            </div>

            {[1, 2, 3, 4].map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className="card"
                  style={{ marginBottom: 5, cursor: "pointer" }}
                >
                  <div
                    className="card-header"
                    onClick={() => toggleAccordion(index)}
                    style={{ backgroundColor: "#D2EBF6" }}
                  >
                    <div className="row">
                      <div className="col-md-1 d-flex justify-content-center align-items-center">
                        <span style={{ fontSize: 28, fontWeight: 700 }}>{item}</span>
                      </div>
                      <div className="col-md-10">
                        <p className="btn-pag39 fontS-18">
                          {index === 0 && (
                            <>
                              <strong>Diâmetro da Tubulação</strong>
                              <img
                                src="./img/icon/seta_indica_azul.svg"
                                alt=""
                                className="pulse-image"
                                style={{
                                  position: "absolute",
                                  maxWidth: 35,
                                  right: -25,
                                  bottom: 0,
                                }}
                              />
                            </>
                          )}
                          {index === 1 && <strong>Material de Tubulação</strong>}
                          {index === 2 && <strong>Isolamento Térmico</strong>}
                          {index === 3 && <strong>Conexões e Acessórios Específicos</strong>}
                        </p>
                      </div>
                      <div className="col-md-1 d-flex justify-content-end align-items-center">
                        <span style={{ fontSize: 36, fontWeight: 700 }}>
                          {isOpen ? "-" : "+"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {isOpen && (
                    <div className="card-body">
                      {index === 0 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Podemos configurar o diâmetro das tubulações de esgoto sanitário 
                              de acordo com as especificações do projeto e as normas existentes. 
                              A seleção adequada do diâmetro é essencial para garantir que o sistema 
                              tenha a capacidade de transportar os efluentes de forma eficiente, 
                              evitando obstruções e refluxos.
                            </p>
                          </div>                          
                        </div>
                      )}

                      {index === 1 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              A escolha do material da tubulação é determinante para a durabilidade 
                              e eficiência do sistema de esgoto. É possível selecionar entre diferentes 
                              tipos de materiais, como PVC, ferro fundido, concreto, aço inoxidável, entre outros, 
                              com base nas necessidades do projeto e nas condições ambientais.
                            </p>
                          </div>                        
                        </div>
                      )}

                      {index === 2 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Em algumas situações, como na drenagem de água condensadoras de ar-condicionado, 
                              pode ser necessário adicionar isolamento térmico à tubulação de esgoto, para evitar 
                              a condensação na superfície externa dos tubos e conexões.
                            </p>
                          </div>                        
                        </div>
                      )}

                      {index === 3 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Além das tubulações em si, a modelagem de esgotamento sanitário inclui a configuração 
                              de conexões e acessórios específicos, como joelhos, curvas, reduções, registros, sifões, 
                              caixas de inspeção e ralos. Esse componentes são essenciais para direcionar e controlar 
                              o fluxo de resíduos dentro do sistema.
                            </p>
                          </div>                      
                        </div>
                      )}                      
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </article>

        {/* ---------------------------- TELA 5 --------------------------------------- */}

        <article className="post comeco1" style={{  
          display: 'flex', 
          alignItems: 'center',
          backgroundColor: '#ffffff' 
          // display: grupoAtivo  === 'comeco1' ? 'block' : 'none' 
          }}>
          <div className="container" style={{ paddingBottom: '60px'}}>

            <div className="row" style={{marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">            
                <p style={{color: '#000000'}}>
                 Além disso, é importante também seguir alguns requisitos ao inserir tubos de esgoto no modelo. Tais como: 
                </p>
              </div>
            </div>

            <div className="row">            

              <div className="col-md-6" style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                <div style={{ backgroundColor: '#ffffff', width: '75%', maxWidth: '480px', height: '230px', padding: '2%', border: '1px solid #14A5E2', borderRadius: '12px' }}>
                  <div style={{ backgroundColor: '#14A5E2', height: '100%', padding: '5%', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
                       Após inserir todos os ralos e caixas sifonadas, devemos ajustar as alturas dos seus prolongadores para que suas tubulações não fiquem dentro da estrutura, pensando também na questão da saída da tubulação de ventilação do ramal secundário de esgoto;
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6" style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                <div style={{ backgroundColor: '#ffffff', width: '75%', maxWidth: '480px', height: '230px', padding: '2%', border: '1px solid #14A5E2', borderRadius: '12px' }}>
                  <div style={{ backgroundColor: '#14A5E2', height: '100%', padding: '5%', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
                       Como a tubulação de esgoto trabalha com declividade, é mais prático traçar essas tubulações partindo das caixas sifonadas até os pontos de utilização;
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6" style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                <div style={{ backgroundColor: '#ffffff', width: '75%', maxWidth: '480px', height: '230px', padding: '2%', border: '1px solid #14A5E2', borderRadius: '12px' }}>
                  <div style={{ backgroundColor: '#14A5E2', height: '100%', padding: '5%', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
                       Criar cortes e planos de referência e dividir a tela pode auxiliar no traçado dessas tubulações;
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6" style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                <div style={{ backgroundColor: '#ffffff', width: '75%', maxWidth: '480px', height: '230px', padding: '2%', border: '1px solid #14A5E2', borderRadius: '12px' }}>
                  <div style={{ backgroundColor: '#14A5E2', height: '100%', padding: '5%', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
                       Deixe para modelar tubulações com declividade após conectar a rede secundária à rede de esgoto primário, isto é, a que se conecta da caixa sifonada até a tubulação que saiu do vaso sanitário.
                    </p>
                  </div>
                </div>
              </div>
                
            </div>

            {/* <div className="row" style={{ justifyContent: 'center' }}>
              {[1, 2, 3, 4].map((id) => (
                <div className="col-md-5" key={id} style={{ margin: '20px' }}>
                  <div className="card-container" onClick={() => toggleTexto(`beneficio${id}`)}>
                    <div className={`card ${mostraTexto[`beneficio${id}`] ? 'flipped' : ''}`} style={{border: 'none', minHeight: '170px', borderRadius: '15px'}}>
                      <div className="card-face card-front" style={{ backgroundColor: id === 1 ? '#479FC4' : id === 2 ? '#47c47f' : id === 3 ? '#4ab58d' : '#47bfc4' }}>
                        <p className='title-size' style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center' }}>
                           {id === 1 && (
                            <>
                            <img src="./img/module3/modulo3_pag5.1.svg" alt="" style={{width: '20%', maxWidth: '90px'}}/>                   
                            </>
                          )}
                          {id === 1 &&  <img src="./img/icon/seta_indica.svg" alt="" className="pulse-image" style={{ position: "absolute", maxWidth: 35, right: -25, bottom: 40,}} />}
                          {id === 2 && <img src="./img/module3/modulo3_pag5.2.svg" alt="" style={{width: '20%', maxWidth: '90px'}}/>}
                          {id === 3 && <img src="./img/module3/modulo3_pag5.3.svg" alt="" style={{width: '20%', maxWidth: '90px'}}/>}
                          {id === 4 && <img src="./img/module3/modulo3_pag5.4.svg" alt="" style={{width: '20%', maxWidth: '90px'}}/>}
                        </p>
                      </div>
                      <div className="card-face card-back">
                        <p style={{ fontSize: '16px', textAlign: 'center' }}>
                          {id === 1 && "Após inserir todos os ralos e caixas sifonadas, devemos ajustar as alturas dos seus prolongadores para que suas tubulações não fiquem dentro da estrutura, pensando também na questão da saída da tubulação de ventilação do ramal secundário de esgoto;"}
                          {id === 2 && "Como a tubulação de esgoto trabalha com declividade, é mais prático traçar essas tubulações partindo das caixas sifonadas até os pontos de utilização;"}
                          {id === 3 && "Criar cortes e planos de referência e dividir a tela pode auxiliar no traçado dessas tubulações;"}
                          {id === 4 && "Deixe para modelar tubulações com declividade após conectar a rede secundária à rede de esgoto primário, isto é, a que se conecta da caixa sifonada até a tubulação que saiu do vaso sanitário."}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div> */}
            
          </div>
        </article>


        {/* ---------------------------- TELA 6 --------------------------------------- */}

        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">              
                <p style={{color: '#ffffff'}}>
                  Agora, acompanhe no vídeo a seguir, com o nosso especialista Dimitri Ferraz, como definir tipos de tubulações de esgoto no Revit. 
                </p>
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/w0a0O0MYDqI?si=Yr4WeLl_jO5QTtg4" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>   
        
          </div>
        </article>


        {/* ---------------------------- TELA 7 --------------------------------------- */}

        <article
          className="post comecoM2-p3-1t"
          style={{ 
            // display: "none", 
          }}
        >
          <div className="container" style={{paddingBottom:'60px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#ffffff' }}>              
                <p>
                  Além das principais tubulações, o Revit também permite modelar as tubulações de ventilação dos ramais, que podem ser criadas tanto em vistas de planta quanto em elevações. Se optar pela vista em planta, fique atento: é importante ajustar corretamente o deslocamento ou elevação para garantir que a ventilação se conecte de forma adequada à tubulação de esgoto. 
                </p>                 
              </div>
                 
                <div className="row" style={{justifyContent: 'center'}}>
                  <div className="col-md-5" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{color: '#ffffff', padding: '8% 5%', backgroundColor: '#131326', borderRadius: '8px'}}>
                      Para configurar esse sistema no Revit, selecione a tubulação, vá em Propriedades e altere o tipo de sistema para Ventilação. 
                    </p>
                  </div>
                  <div className='col-md-7' ref={containerRef} style={{textAlign: 'center', padding: '0', overflow: 'hidden', position: 'relative', height: '100%', borderRadius: '12px'}}>
                    {<img src="./img/module3/modulo3_pag7.png" ref={imageRefs.img1} style={{width: '90%', height: 'auto', objectFit: 'contain', display: 'block', borderRadius: '12px'}}/>}
                  </div>     
                </div>
            </div>


            <div className="row" style={{marginTop: '40px'}}>
              <div className="col-md-12 fontS-18" style={{ color: '#ffffff' }}>              
                <p>
                  Como vimos, o Revit permite trabalhar com diferentes tipos de sistemas no modelo hidrossanitário, desde os pré-configurados no template até a criação de novos, além da possibilidade de editar ou até excluir sistemas existentes, essa flexibilidade garante que o projeto seja adaptado às necessidades reais da obra. 
                </p>   
                <p>
                  A seguir, você verá como os filtros e modelos de vista podem facilitar a visualização e organização desses sistemas no modelo.
                </p>                   
              </div>
            </div>



          </div>
        </article>      

        
        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}

        <article id='l3id3'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module3/topico3-m3.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>



        {/* ---------------------------- TELA 8 --------------------------------------- */}

        <article
          className="post comecoM2-p3-1t"
          style={{ 
            // display: "none", 
          }}
        >
          <div className="container" style={{paddingBottom:'60px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#ffffff' }}>              
                <p>
                  Durante a modelagem hidrossanitárias, especialmente em sistemas mais complexos, a organização visual é fundamental para garantir clareza no projeto. No Revit, isso é feito por meio de filtros e modelos de vista (View Templates), que permitem personalizar como os elementos são exibidos sem alterar suas propriedades físicas. 
                </p>                 
              </div>
                 
                <div className="row" style={{justifyContent: 'center'}}>
                  <div className="col-md-4" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{color: '#ffffff'}}>
                      Para criamos ou editarmos os filtros no Revit, abrimos a guia Vista{"->"} Visibilidade/gráficos (ou atalho VG) e acessamos a aba filtros. Nela podemos modificar a visibilidade, cores, padrões e a transparência de determinados elementos. 
                    </p>
                  </div>
                  <div className='col-md-8' ref={containerRef2} style={{textAlign: 'center', padding: '0', overflow: 'hidden', position: 'relative', height: '100%', borderRadius: '12px'}}>
                    {<img src="./img/module3/modulo3_pag8.png" ref={imageRefs2.img1} style={{width: '100%', height: 'auto', objectFit: 'contain', display: 'block', borderRadius: '12px'}}/>}
                  </div>     
                </div>
            </div>

          </div>
        </article>      

        {/* ---------------------------- TELA 9 --------------------------------------- */}

        <article className="post avanco5-M2-t" style={{ 
          backgroundColor: '#ffffff'
          // display: 'none' 
          }}>
          <div className="container">         

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                  Os modelos de vista permitem salvar essas configurações visuais e aplicá-las em diferentes vistas do projeto, garantindo padronização na apresentação dos desenhos, facilitando a geração da documentação técnica.  
                </p>                          
              </div>
            </div>

            <div className="row" style={{ backgroundColor: '#489FC4', display: 'flex', justifyContent: 'center', marginTop: 30, marginBottom: 60, borderRadius: 12, padding: '2%' }}>
              <div className="col-md-2">
                <img src="./img/module3/modulo3_exclama.svg" alt="" />
              </div>
              <div className="col-md-10 fontS-18" style={{ marginTop: '2%', color: '#ffffff', fontWeight: 500 }}>
                <p>
                  <strong>Fique de olho!</strong> Você pode criar modelos de vista para aplicar em diversas situações, seja para detalhes, elevações, vistas isométricas e etc. Para a separação de plantas de piso por subdisciplina podemos duplicar as vistas correspondentes.   
                </p>                
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                  Acompanhe no vídeo a seguir, como inserir tubulação de esgoto, filtros e modelo de vista no Revit.
                </p>                                 
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/ZBfUc7Qdtx8?si=--7vL24PUSBTYKVn" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>
            
            <div className="row" style={{paddingBottom: '40px'}}>
              <div className="col-md-12 fontS-18">
                <p>
                  Agora que você já sabe como inserir tubulação de esgoto, filtros e modelo de vista no Revit, vamos entender como funciona o editor de sistema.
                </p>                                 
              </div>
            </div>
          
          </div>
        </article>

        
        
        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}

        <article id='l3id4'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module3/topico4-m3.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>



        {/* ---------------------------- TELA 10 --------------------------------------- */}

        <article
          className="post comecoM2-p3-1t"
          style={{ 
            // display: "none", 
          }}
        >
          <div className="container" style={{paddingBottom:'60px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#ffffff', marginBottom: '40px' }}>              
                <p>
                  O Editor do Sistema no Revit é usado para ajustar a rede de tubulações, permitindo analisar e modificar as conexões, trajetos e componentes de um sistema hidráulico de forma gráfica e interativa. No caso do esgotamento sanitário, ele garante que as tubulações estejam corretamente conectadas aos aparelhos e aos coletores, respeitando inclinações e a continuidade do fluxo por gravidade. 
                </p>                 
              </div>
                 
                <div className="row" style={{justifyContent: 'center'}}>
                  <div className="col-md-4" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{color: '#ffffff'}}>
                      Ao abrir o Editor do Sistema, o projetista visualiza um diagrama esquemático com todos os elementos do sistema selecionado, como tubos, conexões e dispositivos sanitários. Isso facilita a identificação de inconsistências, como conexões ausentes, ramais desconectados ou peças incorretas.   
                    </p>
                  </div>
                  <div className='col-md-8' ref={containerRef3} style={{textAlign: 'center', padding: '0', overflow: 'hidden', position: 'relative', height: '100%', borderRadius: '12px'}}>
                    {<img src="./img/module3/modulo3_pag10.png" ref={imageRefs3.img1} style={{width: '100%', height: 'auto', objectFit: 'contain', display: 'block', borderRadius: '12px'}}/>}
                  </div>     
                </div>
            </div>

          </div>
        </article>     

        {/* ---------------------------- TELA 11 --------------------------------------- */}

        <article
          className="post avanco1-M2-p3-1t"
          style={{
            backgroundColor: '#131326'          
          }}
        >
          <div className="container">
            <div className="row d-flex align-items-center justify-content-center fontS-18">
              <p style={{color: '#ffffff'}}>                
                Acompanhe a seguir na prática, como utilizar o editor de sistema no Revit. 
              </p>

                <div style={{ width: "80%", minHeight: "500px", display: "flex", justifyContent: "center" }}>
                  <iframe
                    width="100%"
                    height="auto"
                    src="https://www.youtube.com/embed/2YIaYXchQJ4?si=wCJT0JPN1k4p7CIW"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </div>
            </div>

            <div className="row" style={{marginTop: '60px'}}>
              <div className="col-md-12" style={{ color: '#ffffff' }}>              
                <p>
                  Além do editor de sistema, temos também a possibilidade de realizar alteração de rotas no Revit, vamos acompanhar.  
                </p>                 
              </div>
            </div>
          </div>
        </article> 

        
        
        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}

        <article id='l3id5'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module3/topico5-m3.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>  



        {/* ---------------------------- TELA 12 --------------------------------------- */}

        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  A alteração da solução de rota refere-se à capacidade de modificar o caminho das tubulações, isso pode ser necessário para evitar obstáculos, reduzir perdas de pressão ou melhorar a eficiência geral do sistema. Podemos realizar o ajuste na trajetória de uma tubulação utilizando comandos de arrastar e soltar, ou até mesmo editar diretamente no modelo. Quando fazemos essas alterações o software recalcula automaticamente a quantidade de tubos e/ou conexões afetadas. 
                </p>
                <p style={{color: '#ffffff'}}>
                  Acompanhe na prática, com o nosso especialista, como realizar essas alterações no Revit. 
                </p>
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/krRLSrbAi-c?si=BBDlc5hzz8mqohi4" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>
        
          </div>
        </article>  

        
        
        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}

        <article id='l3id6'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module3/topico6-m3.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>

    
        {/* ---------------------------- TELA 13 --------------------------------------- */}

        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  O isolamento de tubulação é um recurso que facilita a visualização e edição de partes específicas do sistema, ocultando temporariamente os elementos que não são relevantes para a operação que está sendo realizada. Essa funcionalidade é muito útil em projetos de esgotamento sanitário, onde há diversos ramais interligados em que é necessário focar em uma única rede ou trecho para ajustar rotas, conexões ou verificar interferências. 
                </p>
                <p style={{color: '#ffffff'}}>
                  Acompanhe no vídeo a seguir como realizar esse processo no Revit. 
                </p>
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/MGafkufMrPc?si=nwgaLYl5QT1coich" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>
        
          </div>
        </article>  

        
        
        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}

        <article id='l3id7'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module3/topico7-m3.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>


    
        {/* ---------------------------- TELA 14 --------------------------------------- */}
        <article
          className="post comecoM2-p3-1t"
          style={{ 
            // display: "none", 
          }}
        >
          <div className="container" style={{paddingBottom:'60px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#ffffff' }}>              
                <p>
                  Os identificadores permitem atribuir automaticamente dados aos elementos do modelo, enquanto a planta de detalhes complementa esse processo ao destacar as áreas críticas trazendo mais clareza e informação. Esse recurso facilita a interpretação do projeto, especialmente em pontos complexos do sistema de esgoto, como junções e mudanças de direção. 
                </p>                 
              </div>
                 
                <div className="row" style={{justifyContent: 'center'}}>
                  <div className="col-md-5" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{color: '#ffffff'}}>
                      Para fazer a indicação de elementos no Revit, acessamos a guia Anotar{"->"}Identificar por categoria. Com isso podemos fazer a identificação de elementos do projeto como o diâmetro de tubulações, identificar caixas, acessórios de tubulação e etc.
                    </p>
                  </div>
                  <div className='col-md-7' ref={containerRef4} onMouseMove={applyZoom4} onMouseLeave={resetZoom4} style={{textAlign: 'center', padding: '0', overflow: 'hidden', position: 'relative', height: '100%', borderRadius: '12px'}}>
                    {<img src="./img/module3/modulo3_pag14.png" ref={imageRefs4.img1} alt="Zoom 1" id="zoom-image1" style={{width: '100%', height: 'auto', cursor: 'zoom-in', objectFit: 'contain', display: 'block', borderRadius: '12px'}}/>}
                  </div>     
                </div>
            </div>

          </div>
        </article>  

    
        {/* ---------------------------- TELA 15 --------------------------------------- */}

        <article
          className="post comecoM2-t"
          style={{ 
            // display: "none", 
            backgroundColor: "#ffffff" 
          }}
        >
          <div className="container" style={{paddingBottom: '60px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18">
                <p style={{ color: "#000000" }}>
                  É possível ainda, modificar o identificador clicando em cima do mesmo e depois na opção editar família. Por exemplo, para alterar o prefixo do símbolo de diâmetro de tubulação para a letra grega Ø, basta selecionarmos a opção editar legenda e inserir o prefixo, ao concluir podemos fechar o editor de família na opção carregar no projeto e fechar. 
                </p>               
              </div>
            </div>
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
                marginBottom: "40px",
              }}
            >
              <div className='col-md-8'>
                <img src="./img/module3/modulo3_pag15.png" style={{width: '100%'}} alt="A imagem mostra como editar uma legenda no software Revit." />
              </div>

            </div>
            

          </div>
        </article>




        {/* ---------------------------- TELA 16 --------------------------------------- */}
        <article
          className="post comecoM2-t"
          style={{ 
            // display: "none", 
            // backgroundColor: "#ffffff" 
          }}
        >
          <div className="container" style={{paddingBottom: '60px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18">
                <p style={{ color: "#ffffff" }}>
                  Já as ampliações, ou planta de detalhes, podem ser criadas a partir da guia Vista{"->"}Chamada de detalhe. Nele fazemos a seleção, de um banheiro ou uma cozinha, por exemplo, onde podemos definir escala, nível de detalhe e inserimos identificadores dos componentes. 
                </p>               
              </div>
            </div>
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
                marginBottom: "40px",
              }}
            >
              <div className='col-md-8' style={{display: "flex", justifyContent: "center",}}>
                <img src="./img/module3/modulo3_pag16.png" style={{width: '80%'}} alt="A imagem mostra a criação de chamada de detalhe no software Revit." />
              </div>

            </div>
            

          </div>
        </article>


        {/* ---------------------------- TELA 17 --------------------------------------- */}
        <article
          className="post comecoM2-t"
          style={{ 
            // display: "none", 
            backgroundColor: "#EDE6D8" 
          }}
        >
          <div className="container" style={{paddingBottom: '60px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18">
                <p style={{ color: "#000000" }}>
                  As vistas isométricas podem ser criadas, basicamente de duas formas: Clicamos na guia Vista{"->"}Vista 3D{"->"} Vista 3D padrão ou selecionamos os elementos que queremos que façam parte da vista, acessamos a guia Modificar{"->"}Vista{"->"}Caixa de Seleção (ou usamos o atalho do teclado, digitando as teclas BX).
                </p>    
                <p style={{ color: "#000000" }}>
                  Ao abrir a vista, modificamos a disciplina para hidráulica, ajustamos a posição da vista utilizando o cubo, definimos os limites da caixa de corte e, por fim, utilizamos a opção “Salvar a orientação e bloquear vista”.  
                </p>           
              </div>
            </div>
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
                marginBottom: "40px",
              }}
            >
              <div className='col-md-8' style={{display: "flex", justifyContent: "center",}}>
                <img src="./img/module3/modulo3_pag17.png" style={{width: '80%'}} alt="A imagem mostra como salvar uma orientação de uma vista 3D no software Revit." />
              </div>

            </div>
            

          </div>
        </article>

        {/* ---------------------------- TELA 18 --------------------------------------- */}
        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  Agora que você já sabe todos esses pontos, acompanhe a seguir, como inserir identificadores no projeto e criar planta de detalhes do modelo.   
                </p>                
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/bPbmzdNAB2U?si=kpsDCUNKixdzXFHo" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

            
            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  Ao finalizar a modelagem do sistema hidrossanitário, você seguirá para outro processo muito importante, as configurações finais do projeto para posterior impressão. 
                </p>              
              </div>
            </div>
        
          </div>
        </article>  

        
        
        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}

        <article id='l3id8'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module3/topico8-m3.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>




        {/* ---------------------------- TELA 19 --------------------------------------- */}
        
        <article className="post avanco5-M2-t" style={{ 
          backgroundColor: '#ffffff'
          // display: 'none' 
          }}>
          <div className="container" style={{paddingBottom: '120px'}}>         

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                  Após concluir a modelagem do sistema hidrossanitário, é fundamental gerar a documentação técnica que será utilizada para execução da obra. Essa etapa transforma o modelo digital em informações claras e organizadas, como plantas, cortes, elevações, tabelas de quantitativos e folhas de impressão, garantindo que todas as equipes envolvidas possam interpretar corretamente o projeto. 
                </p>                          
              </div>
            </div>

            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
                marginBottom: "40px",
              }}
            >
              <div className='col-md-8' style={{display: "flex", justifyContent: "center",}}>
                <img src="./img/module3/modulo3_pag18.jpg" style={{width: '80%'}} alt="" />
              </div>

            </div>

            <div className="row" style={{ backgroundColor: '#489FC4', display: 'flex', justifyContent: 'center', marginTop: 60, borderRadius: 12, padding: '2%' }}>
              <div className="col-md-2">
                <img src="./img/module3/modulo3_exclama.svg" alt="" />
              </div>
              <div className="col-md-10 fontS-18" style={{ marginTop: '2%', color: '#ffffff', fontWeight: 500 }}>
                <p>
                  <strong>Atenção! </strong>No contexto do BIM, a documentação não é criada do zero, mas sim extraída diretamente do modelo, assegurando que qualquer atualização seja refletida em todas as vistas e documentos de forma automática. Essa integração evita erros de inconsistência entre desenho e modelo, aumentando a confiabilidade das informações.    
                </p>                
              </div>
            </div>
          
          </div>
        </article>


        {/* ---------------------------- TELA 20 --------------------------------------- */}
        
        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  Acompanhe a seguir de forma prática, como realizar as configurações para extrair a documentação técnica no Revit.
                </p>                
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/GDUL8O7hinY?si=wKuJ9u5Kul8YSpjt" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

            
            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  Além dessas configurações, é necessário realizar também as configurações para a plotagem e impressão desse projeto. Vamos entender esse processo.
                </p>              
              </div>
            </div>
        
          </div>
        </article>  

        
        
        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}

        <article id='l3id9'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module3/topico9-m3.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>


        {/* ---------------------------- TELA 21 --------------------------------------- */}
       
        <article
          className="post comecoM2-t"
          style={{ 
            // display: "none", 
            backgroundColor: "#EDE6D8" 
          }}
        >
          <div className="container" style={{paddingBottom: '60px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18">
                <p style={{ color: "#000000" }}>
                  A plotagem ou impressão de modelos digitais de projetos é a materialização e representação física de desenhos digitais. Essa integração entre o mundo digital e o físico simplifica a comunicação dos membros da equipe e permite uma análise mais detalhada das instalações projetadas. 
                </p>                       
              </div>
            </div>
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
                marginBottom: "40px",
              }}
            >
              <div className='col-md-8' style={{display: "flex", justifyContent: "center",}}>
                <img src="./img/module3/modulo3_pag21.gif" style={{width: '80%'}} alt="O GIF mostra a impressão de um esboço de projeto na gráfica." />
              </div>

            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p style={{ color: "#000000" }}>
                  Antes de imprimir o projeto é importante realizar as configurações de pena, escala, escolher a versão adequada do software, e ter atenção aos formatos de arquivos. Esses cuidados garantem a qualidade e fidelidade nessa transição do digital para o físico.   
                </p>                       
              </div>
            </div>
            

          </div>
        </article>
                                

       
        {/* ---------------------------- TELA 22 --------------------------------------- */}
        
        <article className="post avanco3-M2-t" style={{ backgroundColor: "#131326", display: 'flex', alignItems: 'center'}}>
          <div className="container" style={{ marginBottom: "60px" }}>
            <div className="row">             
              <p className="fontS-18" style={{ color: "#ffffff", marginBottom: '60px' }}>
                As configurações de penas referem-se às definições relacionadas à espessura, estilo e cor das linhas utilizadas em desenhos técnicos e projetos. Para a plotagem de projetos, essas configurações correspondem a apresentação visual das informações contidas nos desenhos. 
              </p>
              <p className="fontS-18" style={{ color: "#ffffff", marginBottom: '60px' }}>
                Para realizar a configuração gráfica dos projetos, devemos considerar os seguintes pontos: 
              </p>
            </div>

            {[1, 2, 3, 4, 5].map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className="card"
                  style={{ marginBottom: 5, cursor: "pointer" }}
                >
                  <div
                    className="card-header"
                    onClick={() => toggleAccordion(index)}
                    style={{ backgroundColor: "#D2EBF6" }}
                  >
                    <div className="row">
                      <div className="col-md-1 d-flex justify-content-center align-items-center">
                        <span style={{ fontSize: 28, fontWeight: 700 }}>{item}</span>
                      </div>
                      <div className="col-md-10">
                        <p className="btn-pag39 fontS-18">
                          {index === 0 && (
                            <>
                              <strong>Espessura da Linha</strong>
                              <img
                                src="./img/icon/seta_indica_azul.svg"
                                alt=""
                                className="pulse-image"
                                style={{
                                  position: "absolute",
                                  maxWidth: 35,
                                  right: -25,
                                  bottom: 0,
                                }}
                              />
                            </>
                          )}
                          {index === 1 && <strong>Estilo da Linha</strong>}
                          {index === 2 && <strong>Cor da Linha</strong>}
                          {index === 3 && <strong>Destaque Hierárquico</strong>}
                          {index === 4 && <strong>Padronização</strong>}
                        </p>
                      </div>
                      <div className="col-md-1 d-flex justify-content-end align-items-center">
                        <span style={{ fontSize: 36, fontWeight: 700 }}>
                          {isOpen ? "-" : "+"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {isOpen && (
                    <div className="card-body">
                      {index === 0 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              essa configuração auxilia no destaque de elementos específicos do desenho, como paredes, tubulações, fiações elétricas, etc. Linhas mais espessas podem ser usadas para elementos mais importantes, proporcionando destaque visual.
                            </p>
                          </div>                          
                        </div>
                      )}

                      {index === 1 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              é o padrão de traço utilizado. Pode incluir linhas contínuas, tracejadas, pontilhadas, 
                              entre outros. A escolha do estilo da linha pode ser utilizada para diferenciar tipos 
                              de elementos no desenho, como indicar diferentes materiais, limites ou estados 
                              (por exemplo, linhas de demarcação).
                            </p>
                          </div>                        
                        </div>
                      )}

                      {index === 2 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              determina a cor em que as linhas serão impressas. Embora muitos desenhos técnicos sejam 
                              geralmente impressos em preto e branco, a configuração de cor ainda é relevante quando 
                              se trabalha em ambientes digitais. Pode ser usada para fins de organização, especialmente 
                              ao trabalhar com layers e diferentes disciplinas em um modelo BIM.
                            </p>
                          </div>                        
                        </div>
                      )}

                      {index === 3 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              quando elementos críticos podem ser representados de forma mais proeminente, em destaque 
                              hierárquico, enquanto detalhes menos relevantes podem ser apresentados de maneira mais 
                              sutil.
                            </p>
                          </div>                      
                        </div>
                      )}                      

                      {index === 4 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              A padronização das configurações de penas garante a consistência em todos os desenhos 
                              de um projeto. Isso facilita a interpretação e compreensão por parte de diferentes 
                              profissionais que podem interagir com os desenhos ao longo do ciclo de vida do projeto.
                            </p>
                          </div>                      
                        </div>
                      )}                      
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </article>
       

        {/* ---------------------------- TELA 23 --------------------------------------- */}

        <article className="post avanco3-M2-t" style={{ 
          // display: 'none' 
          backgroundColor: "#ffffff",
          }}>
     
          <div className="container" style={{paddingBottom: '60px'}}>
            <div className="row">            
              <div className="col-md-12 fontS-18">
                <p>
                  Já a configuração de escala, refere-se à relação proporcional entre as dimensões de um objeto representado no papel (ou em um ambiente digital) e as dimensões reais desse objeto no mundo real. Ou seja, a escala é um fator de conversão que permite representar objetos em diversos tamanhos em uma folha, seja ela física ou digital, para facilitar a visualização e interpretação, sem comprometer a precisão das medidas.
                </p>              
              </div>
            </div>
            <div className="row" style={{ display: 'flex', justifyContent: 'center', marginTop: '30px', marginBottom: '40px' }}>
              <img src="./img/module3/modulo3_pag23.png" style={{ width: '70%' }} alt="A imagem mostra o exemplo de barras de escala para projetos." />
            </div>

          </div>
        </article>

        {/* ---------------------------- TELA 24 --------------------------------------- */}
        <article className="post avanco3-M2-t" style={{ backgroundColor: "#131326", display: 'flex', alignItems: 'center'}}>
          <div className="container" style={{ marginBottom: "60px" }}>
            <div className="row">             
              <p className="fontS-18" style={{ color: "#ffffff", marginBottom: '60px' }}>
                As escalas podem ser de três formas, a natural, de ampliação e de redução. Veja as características de cada uma delas: 
              </p>              
            </div>

            {[1, 2, 3,].map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className="card"
                  style={{ marginBottom: 5, cursor: "pointer" }}
                >
                  <div
                    className="card-header"
                    onClick={() => toggleAccordion(index)}
                    style={{ backgroundColor: "#D2EBF6" }}
                  >
                    <div className="row">
                      <div className="col-md-1 d-flex justify-content-center align-items-center">
                        <span style={{ fontSize: 28, fontWeight: 700 }}>{item}</span>
                      </div>
                      <div className="col-md-10">
                        <p className="btn-pag39 fontS-18">
                          {index === 0 && (
                            <>
                              <strong>Escala Natural</strong>
                              <img
                                src="./img/icon/seta_indica_azul.svg"
                                alt=""
                                className="pulse-image"
                                style={{
                                  position: "absolute",
                                  maxWidth: 35,
                                  right: -25,
                                  bottom: 0,
                                }}
                              />
                            </>
                          )}
                          {index === 1 && <strong>Escala de Ampliação</strong>}
                          {index === 2 && <strong>Escala de Redução</strong>}                      
                        </p>
                      </div>
                      <div className="col-md-1 d-flex justify-content-end align-items-center">
                        <span style={{ fontSize: 36, fontWeight: 700 }}>
                          {isOpen ? "-" : "+"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {isOpen && (
                    <div className="card-body">
                      {index === 0 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <ul>
                              <li>Representação fiel das dimensões dos objetos no papel em relação às suas dimensões reais;</li>
                              <li>Cada unidade no desenho corresponde exatamente a uma unidade no mundo real;</li>
                              <li>Exemplo: 1:1</li>
                            </ul>
                          </div>                          
                        </div>
                      )}

                      {index === 1 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <ul>
                              <li>É utilizada para destacar detalhes específicos, onde as dimensões no desenho são maiores do que as dimensões reais;</li>
                              <li>Exemplo: 2:1, 5:1, 10:1.</li>
                            </ul>
                          </div>                        
                        </div>
                      )}

                      {index === 2 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <ul>
                              <li>Quando é necessário representar um objeto maior ou uma área extensa em um espaço limitado, sendo que as dimensões no desenho são menores do que as dimensões reais;</li>
                              <li>São ferramentas fundamentais na criação de desenhos técnicos, pois permite adaptar a representação visual à finalidade do projeto;</li>
                              <li>Exemplo: 1:2, 1:5, 1:10.</li>
                            </ul>
                          </div>                        
                        </div>
                      )}

                    </div>
                  )}
                </div>
              );
            })}


            <div className="row">
              <div className="col-md-12 fontS-18">
                <p style={{color: '#ffffff'}}>
                  A seguir, acompanhe com nosso especialista Valter Junior, como realizar as configurações de Pena e Escala no Revit.   
                </p>                              
              </div>
            </div>


            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px', marginTop: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/Nd1TSY8vjD8?si=WUQRcK_eHKgQS1d2" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>


            <div className="row">
              <div className="col-md-12 fontS-18">
                <p style={{color: '#ffffff'}}>
                  Além dessas configurações, outro ponto que devemos ter atenção ao realizar as configurações para impressão do projeto são as versões dos softwares utilizados.  
                </p>                              
              </div>
            </div>


          </div>
        </article>


        {/* ---------------------------- TELA 25 --------------------------------------- */}
        
        <article className="post avanco3-M2-t" style={{ 
          // display: 'none' 
          backgroundColor: "#ffffff",
          }}>
     
          <div className="container" style={{paddingBottom: '60px'}}>
            <div className="row">            
              <div className="col-md-12 fontS-18">
                <p>
                  No processo de plotagem, a escolha da versão do software garante a compatibilidade com o modelo digital. Softwares como Autodesk Revit, por exemplo, são atualizados anualmente.
                </p>              
              </div>
            </div>
            <div className="row" style={{ display: 'flex', justifyContent: 'center', marginTop: '30px', marginBottom: '40px' }}>
              <img src="./img/module3/modulo3_pag25.png" style={{ width: '70%' }} alt="A imagem mostra o layout da tela referente a Versão do software Autodesk Revit 2024." />
            </div>

            <div className="row">            
              <div className="col-md-12 fontS-18">
                <p>
                  Essas atualizações são importantes, pois trazem melhorias de desempenho e correções de bugs, além de garantir a compatibilidade com outras ferramentas e equipamentos de plotagem. 
                </p>              
              </div>
            </div>

          </div>
        </article>


        {/* ---------------------------- TELA 26 --------------------------------------- */}
        <article className="post avanco5-M2-t" style={{ 
          // display: 'none', 
          backgroundColor: '#EDE6D8' 
          }}>
          <div className="container" style={{ marginBottom: 60, marginTop: '2%' }}>
            <div className="row" style={{ marginBottom: 30 }}>
              <p className='title-size' style={{ fontSize: 36, color: '#00A8D0', fontWeight: 500 }}>
                <strong>Formatos de Arquivos</strong> 
              </p>
              <p style={{color: '#000000' }}>
                Os formatos de arquivos influenciam diretamente a qualidade da plotagem. O formato <strong>.RVT</strong> (Revit) é ideal para manter todas as informações do modelo. No entanto, ao exportar para a plotagem, formatos como <strong>.PLT</strong> (HPGL) e <strong>.STL</strong> (para modelos 3D) podem ser mais adequados, dependendo dos requisitos específicos da impressão e do equipamento utilizado.  
              </p>
              <p style={{color: '#000000' }}>
                É possível também exportar para arquivos do tipo <strong>PDF</strong> (Portable Document Format). Formato interessante para compartilhar documentos de projeto, sendo universalmente acessível, eficaz para revisões, colaboração e apresentação de informações, garantindo que a formatação seja preservada. Além dos já citados é possível ainda fazer a exportação em <strong>DWG</strong>, que podem ser abertos em softwares CAD.
              </p>           
            </div>
        
          </div>
        </article>
                         

        {/* ---------------------------- TELA 27 --------------------------------------- */}
        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '60px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  Acompanhe no vídeo a seguir o processo de exportação de arquivos PLT, STL, PDF e DWG no REVIT.
                </p>                          
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/8umytpNGH8U?si=Evb6xV6lgVgwmuSX" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

              <div className="row">
              <div className="col-md-12 fontS-18">               
                <p style={{color: '#ffffff'}}>
                  Como pudemos ver, várias extensões de arquivos podem ser exportadas em um software BIM, como o Revit. Embora cada um deles existe uma funcionalidade específica, atualmente os arquivos em PDF ganharam maior espaço, pois acabam por preservar a formatação dos arquivos e serem abertos com facilidade em diversas plataformas, como computador, tablet e celular.
                </p>                          
                <p style={{color: '#ffffff'}}>
                  Agora o seu modelo já está pronto para ser entregue com qualidade, representando de forma precisa tudo o que foi planejado, garantindo segurança e confiabilidade para a sua execução.
                </p>                          
              </div>
            </div>

        
          </div>
        </article>


        {/*---------------------------- TELA QUESTÔES ---------------------------------- --> */}
        
        <article
          className="post avanco7-M2-t"
          style={
            {
              // display: "none",
              // backgroundColor: "#ffffff"
            }
          }
        >
          <div className="container">
            {/* ENCERRAMENTO DO MÓDULO */}
            <div
              style={{
                backgroundColor: "#EDE6D8",
                padding: "60px 20px",
                borderRadius: "12px",
                textAlign: "center",
                marginTop: "60px",
                marginBottom: "60px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <h2
                style={{
                  color: "#131326",
                  fontSize: "32px",
                  fontWeight: "700",
                  marginBottom: "25px",
                }}
              >
                🛠️ Vamos exercitar?
              </h2>

              <p
                style={{
                  color: "#131326",
                  fontSize: "18px",
                  lineHeight: "1.6",
                  maxWidth: "800px",
                  margin: "0 auto 30px auto",
                  textAlign: "justify",
                }}
              >
                Que tal praticar um pouco do que vimos aqui? 
                Preparamos um roteiro com orientações simples para te ajudar a começar. A proposta para essa etapa será realizar a documentação técnica do Projeto Hidrossanitário desenvolvido por você na prática anterior. Vamos lá?
              </p>

              <div style={{ marginTop: "30px" }}>
                <p
                  style={{
                    color: "#131326",
                    fontSize: "20px",
                    fontWeight: "600",
                    marginBottom: "15px",
                  }}
                >
                  📥 Baixe aqui o arquivo do Exercitando.
                </p>

                <div className="row">
                  
                </div>

                <a
                  onClick={() => {
                  const link = document.createElement('a');
                  link.href = './downloads/exercitando3.docx';
                  link.download = 'Exercitando3.docx';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
                  style={{
                    display: "inline-block",
                    backgroundColor: "#131326",
                    color: "#EDE6D8",
                    padding: "12px 30px",
                    borderRadius: "8px",
                    textDecoration: "none",
                    fontSize: "18px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                    marginRight: '15px'
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#0c59a1ff", e.currentTarget.style.cursor = 'pointer')
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#131326")
                  }
                >
                  ⬇️ Download do Roteiro Exercitando 3
                </a>
              </div>
            </div>
          </div>
        </article>
        


        {/* ---------------------------- TELA 28 --------------------------------------- */}
        
        <article
          className="avanco5-M2-p3-1f"
          style={{
            display: "flex",
            minHeight: "100vh",
            backgroundColor: '#131326',
            // backgroundImage: "url(./img/module3/bg_modulo3_parte1_pag45.png)",
            // backgroundRepeat: "no-repeat",
            // backgroundSize: "cover"
          }}
        >
          <div className="container" style={{ display: "flex", justifyContent: "center", width: "80%" }}>
            <div className="row" style={{ justifyContent: "center", alignItems: "center", marginBottom: "60px" }}>
              <div
                className="col-md-8 fontS-18"
                style={{
                  padding: "5% 7%",
                  minHeight: "400px",
                  background: "linear-gradient(133deg, rgb(255 255 255 / 94%) 15%, rgb(215 215 215 / 94%) 75%)",
                  borderRadius: "12px"
                }}
              >
                <p>
                  <strong>Parabéns! Você concluiu o curso de Projetos Hidrossanitários</strong>   
                </p>
                <p>
                  Chegamos ao final de nossa jornada de aprendizagem! Ao longo do curso, você conheceu os fundamentos da Modelagem da Informação da Construção (BIM) aplicados a projetos hidrossanitários, desde a preparação do ambiente e configuração de arquivos até a criação de um fluxo de trabalho eficiente e organizado.
                </p>
                <p>
                  Você também aprendeu a configurar as tubulações de água fria e quente no Revit, definindo materiais, conexões e parâmetros técnicos essenciais, e finalizou com a modelagem das instalações de esgoto, incluindo a documentação técnica completa do projeto.
                </p>
                <p>
                  Sua dedicação e empenho foram essenciais para essa conquista. Continue aplicando o que aprendeu e aprimorando suas habilidades profissionais.
                </p>
                <br />
                <p style={{ color: "#0e6b93", fontSize: "22px", fontWeight: 500 }}>
                 <strong>Sucesso!</strong>
                </p>
              </div>
            </div>
          </div>
        </article>
        






      </section>
    </>
  );
};

export default Lesson3;